













































import { computed, defineComponent } from '@vue/composition-api';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import { StateEnum, useAllowlist, useStore } from '@tt4b/ttam-hooks';
import TtamPopoverOnGuide from '@/components/common/popover-on-guide/index.vue';
import { i18n } from './../../../i18n';

const name = 'ttam-identity-type';
export default defineComponent({
  name,
  components: { QuestionTooltip, TtamPopoverOnGuide },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTips: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    guideImage: {
      type: String,
      default:
        'https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/ads_manager/img/identity-op-guide.gif',
    },
    isAco: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { isPangleSupportSparkAdsWhite } = useAllowlist();
    const onInput = (val: boolean) => {
      emit('input', val);
    };
    const popoverGuideId = computed(() => {
      const { state } = useStore();
      const accountInfo = computed(() => state[StateEnum.accountInfo].data.value);
      const aadvid = computed(() => state[StateEnum.baseInfo].value.aadvid);
      const coreUserId = computed(() => accountInfo.value?.core_user?.core_user_id);
      return `creative-identity-type-switch_${aadvid.value}_${coreUserId.value}`;
    });
    const identityTypeHoverContent = computed(() =>
      isPangleSupportSparkAdsWhite.value
        ? i18n.t('module_creative_spark_ads_with_pangle_desc')
        : i18n.t('module_creative_bc_use_tt_account_prompt'),
    );

    return {
      name,
      popoverGuideId,
      identityTypeHoverContent,
      onInput,
    };
  },
});
